module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'form',
        'propertiesForm',
    ],

    config: {
        entityContext: 'employees',
        preventClearOnCancel: true,
        // templates_crew_profile_controller is assigned to handle the statusController.panel
        onSubmitDonePanelMessage: null,
        onSubmitNothingPanelMessage: null,
        refreshAfterSuccessfulSubmit: false,
    },

    methods: {

        onTypeChange(type){
            if(type === 'internal'){
                this.$.addClass('isInternalEmployee')
            } else {
                this.$.removeClass('isInternalEmployee')
            }

            if(type === 'external'){
                this.$.addClass('isExternalEmployee')
            } else {
                this.$.removeClass('isExternalEmployee')
            }

            if(type === 'occasional'){
                this.$.addClass('isOccasionalEmployee')
            } else {
                this.$.removeClass('isOccasionalEmployee')
            }

            this.triggerFind('employeeTypeChanged', { type })
        },

        onCancel(){
            let modal
            this.closest('base_modal_modal', c => modal = c)
            if(modal){
                modal.decide(false)
            }
        },

        onHeartbeat(message, heartbeatPrewarmedResourceHashes){
            // this form does not live long enough to react to heartbeats.
        },
    },

    hooks: {
        _attach($element, options){
            const storage = this.getStorage() || {}
            const employee = (((storage.user || {}).data || {}).userTableAssociates || {}).employee || {}
            this.onTypeChange(employee.type)
        },
    }
}